module.exports = __webpack_public_path__ + "static/media/ForeverCar-Vertical-Logo.31433927.jpg";